/* eslint-disable @typescript-eslint/no-explicit-any */
import { MutationHookOptions, useMutation } from '@apollo/client';
import { GET_TASKS } from './tasks.query';
import { graphql } from '../gql';

export const DELETE_TASK = graphql(`
  mutation deleteTask($taskUuid: String!) {
    deleteTask(taskUuid: $taskUuid) {
      result
    }
  }
`);

export function useDeleteTaskMutation(
  options: MutationHookOptions<any, { taskUuid: string }> = {}
) {
  const [deleteTask, { loading, error, reset }] = useMutation(DELETE_TASK, {
    refetchQueries: [GET_TASKS],
    ...options,
  });

  return {
    deleteTask,
    loading,
    error,
    reset,
  };
}
